import { Email } from '../../models/Email';
import { Container } from '../../models/Container';
import { Sistema } from '../../models/Sistema';
import { Usuario } from '../../models/Usuario';
import { UsuarioPerfil } from '../../models/UsuarioPerfil';
import { UsuarioStatus } from '../../models/UsuarioStatus';
import { TokenAcesso } from '../../models/TokenAcesso';
import { Obra } from '../../models/Obra';
import { ObraPO } from '../../models/ObraPO';
import { ObraRegistro } from '../../models/ObraRegistro';
import { ObraServico } from '../../models/ObraServico';
import { ObraStatusRegistro } from '../../models/ObraStatusRegistro';
import { ObraRegistroParalisacao } from '../../models/ObraRegistroParalisacao';
import { ObraDocumentacao } from '../../models/ObraDocumentacao';
import { ObraDocumentacaoDocumento } from '../../models/ObraDocumentacaoDocumento';
import { ObraDetalhePOMIGO } from '../../models/ObraDetalhePOMIGO';
import { ObraDetalhePOMIGOItem } from '../../models/ObraDetalhePOMIGOItem';
import { ObraRegistroAtraso } from '../../models/ObraRegistroAtraso';
import { ObraEscopo } from '../../models/ObraEscopo';
import { ObraMigoAprovado } from '../../models/ObraMigoAprovado';
import { ObraMySuporte } from '../../models/ObraMySuporte';
import { CADO } from '../../models/CADO';
import { CJI3 } from '../../models/CJI3';
import { CJI5 } from '../../models/CJI5';
import { FBL1N } from '../../models/FBL1N';
import { KE30 } from '../../models/KE30';
import { LogProcessamentoSistema } from '../../models/LogProcessamentoSistema';
import { KSB1 } from '../../models/KSB1';
import { KSBT } from '../../models/KSBT';
import { MB51 } from '../../models/MB51';
import { ZVSD1 } from '../../models/ZVSD1';
import { ZVSD3 } from '../../models/ZVSD3';
import { ZZPOMON } from '../../models/ZZPOMON';
import { ParametroSistema } from '../../models/ParametroSistema';
import { ViewPoIntegMySuporte } from '../../models/ViewPoIntegMySuporte';
import { ViewPOObraMigoAprovado } from '../../models/ViewPOObraMigoAprovado';
import { LoteIntegracaoMigo } from '../../models/LoteIntegracaoMigo';
import { NotaFiscalAniel } from '../../models/NotaFiscalAniel';
import { VendorDataAniel } from '../../models/VendorDataAniel';
import { MaterialDataAniel } from '../../models/MaterialDataAniel';
import { CostCenterAniel } from '../../models/CostCenterAniel';
import { PersonalNumberVendor } from '../../models/PersonalNumberVendor';
import { CN45N } from '../../models/CN45N';
import { CN46N } from '../../models/CN46N';
import { CADO_TR } from '../../models/CADO_TR';
import { CN47N } from '../../models/CN47N';
import { ViewNcmPendenteLoteIntegracao } from '../../models/ViewNcmPendenteLoteIntegracao';
import { ViewLPU } from '../../models/ViewLPU';
import { ViewParametroSistemaEriproc } from '../../models/ViewParametroSistemaEriproc';
import { Pessoa } from '../../models/Pessoa';
import { Funcionario } from '../../models/Funcionario';
import { UserCredential } from '../../models/UserCredential';
import { UserIdentity } from '../../models/UserIdentity';
import { AgendamentoRPA } from '../../models/AgendamentoRPA';
import { FuncaoRPA } from '../../models/FuncaoRPA';
import { FuncaoRPAScript } from '../../models/FuncaoRPAScript';
import { AgendamentoRPAParametro } from '../../models/AgendamentoRPAParametro';
import { LogProcessamentoRPA } from '../../models/LogProcessamentoRPA';
import { Impersonate } from '../../models/Impersonate';
import { ImpersonatePerfilManutencao } from '../../models/ImpersonatePerfilManutencao';
import { LoginSAP } from '../../models/LoginSAP';
export class SDKModels {
  models = {
    Email: Email,
    Container: Container,
    Sistema: Sistema,
    Usuario: Usuario,
    UsuarioPerfil: UsuarioPerfil,
    UsuarioStatus: UsuarioStatus,
    TokenAcesso: TokenAcesso,
    Obra: Obra,
    ObraPO: ObraPO,
    ObraRegistro: ObraRegistro,
    ObraServico: ObraServico,
    ObraStatusRegistro: ObraStatusRegistro,
    ObraRegistroParalisacao: ObraRegistroParalisacao,
    ObraDocumentacao: ObraDocumentacao,
    ObraDocumentacaoDocumento: ObraDocumentacaoDocumento,
    ObraDetalhePOMIGO: ObraDetalhePOMIGO,
    ObraDetalhePOMIGOItem: ObraDetalhePOMIGOItem,
    ObraRegistroAtraso: ObraRegistroAtraso,
    ObraEscopo: ObraEscopo,
    ObraMigoAprovado: ObraMigoAprovado,
    ObraMySuporte: ObraMySuporte,
    CADO: CADO,
    CJI3: CJI3,
    CJI5: CJI5,
    FBL1N: FBL1N,
    KE30: KE30,
    LogProcessamentoSistema: LogProcessamentoSistema,
    KSB1: KSB1,
    KSBT: KSBT,
    MB51: MB51,
    ZVSD1: ZVSD1,
    ZVSD3: ZVSD3,
    ZZPOMON: ZZPOMON,
    ParametroSistema: ParametroSistema,
    ViewPoIntegMySuporte: ViewPoIntegMySuporte,
    ViewPOObraMigoAprovado: ViewPOObraMigoAprovado,
    LoteIntegracaoMigo: LoteIntegracaoMigo,
    NotaFiscalAniel: NotaFiscalAniel,
    VendorDataAniel: VendorDataAniel,
    MaterialDataAniel: MaterialDataAniel,
    CostCenterAniel: CostCenterAniel,
    PersonalNumberVendor: PersonalNumberVendor,
    CN45N: CN45N,
    CN46N: CN46N,
    CADO_TR: CADO_TR,
    CN47N: CN47N,
    ViewNcmPendenteLoteIntegracao: ViewNcmPendenteLoteIntegracao,
    ViewLPU: ViewLPU,
    ViewParametroSistemaEriproc: ViewParametroSistemaEriproc,
    Pessoa: Pessoa,
    Funcionario: Funcionario,
    UserCredential: UserCredential,
    UserIdentity: UserIdentity,
    AgendamentoRPA: AgendamentoRPA,
    FuncaoRPA: FuncaoRPA,
    FuncaoRPAScript: FuncaoRPAScript,
    AgendamentoRPAParametro: AgendamentoRPAParametro,
    LogProcessamentoRPA: LogProcessamentoRPA,
    Impersonate: Impersonate,
    ImpersonatePerfilManutencao: ImpersonatePerfilManutencao,
    LoginSAP: LoginSAP,
    
  };

  get(modelName) {
    return this.models[modelName];
  }

  getAll() {
    return this.models;
  }

  getModelNames() {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/sdk/services/custom/SDKModels.js